;(function ($) {
  $(() => {
    /* Saved Articles load more */
    const savedArticles = $('.js-saved-articles')

    if (savedArticles.length) {
      const loader = $('.js-loader')
      let page = 1
      let isLoading = false

      const loadMoreSavedPosts = () => {
        if (!isLoading) {
          isLoading = true
          loader.addClass('show')
          page++

          const data = new FormData()
          data.append('action', 'load_more_saved_posts')
          data.append('page', page)

          $.ajax({
            url: localize.ajaxurl,
            method: 'POST',
            data,
            processData: false,
            contentType: false,
          })
            .done((data) => {
              if (data.trim().length > 0) {
                savedArticles.append(data)
                isLoading = false
              } else {
                loader.html('<p>No more posts to show.</p>')
                isLoading = true
              }
            })
            .fail((error) => {
              console.error(error)
              loader.html('<p>Error loading posts.</p>')
              loader.removeClass('show')
              isLoading = false
            })
        }
      }

      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0]
          if (entry.isIntersecting) {
            loadMoreSavedPosts()
          }
        },
        {
          rootMargin: '0px',
        }
      )

      observer.observe($('#trigger_load_more_saved_articles')[0])
    }

    /* Tag articles load more */
    const tagArticles = $('.js-tag-articles')

    if (tagArticles.length) {
      const loader = $('.js-loader')
      let page = 1
      let isLoading = false

      const loadMoreTagPosts = () => {
        if (!isLoading) {
          isLoading = true
          loader.addClass('show')
          page++

          const data = new FormData()
          data.append('action', 'load_more_tag_posts')
          data.append('page', page)
          data.append('tag', tagArticles.data('tag'))
        }
      }

      const observerTagPosts = new IntersectionObserver(
        (entries) => {
          const entry = entries[0]
          if (entry.isIntersecting) {
            loadMoreTagPosts()
          }
        },
        {
          rootMargin: '0px',
        }
      )

      observerTagPosts.observe($('#trigger_load_more_tag_articles')[0])
    }
  })
})(jQuery)
